import styled, { css } from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';

export const desktopHeaderHeight = spacing(9.5);
export const HeaderOuter = styled.header`
  /* Should appear above all content, and overlay */
  z-index: 7;

  /* Position relative so that the menus can position themselves below the header. */
  position: relative;
`;

export const MegamenuPlaceholder = styled.div<{
  isSticky?: boolean;
}>`
  ${(props) =>
    !props.isSticky
      ? css`
          height: 0;
        `
      : css`
          height: ${spacing(7)};

          ${mediaQuery.tabletPortrait`
            height: ${spacing(8)};
          `}

          ${mediaQuery.tabletLandscape`
            height: ${desktopHeaderHeight};
          `}
        `}
`;
